import { baseApiClient } from "data/modules/api/api.client";
import { checkIsArrayEmpty } from "features/Common/modules/DataTypes/utils/Array.utils";
import { CHANGE_STATES } from "features/Common/modules/Form/constants/Form.constants";
import { MEMBERSHIP_APIS } from "../constants/Membership.apis";
import { CHANNEL_API_KEYS } from "../constants/MembershipsSection.data";

const postAddMembershipChannels = async ({
  communityListingUuid,
  membershipUuids,
  channelUuids,
  applyToExistingCustomers,
}) => {
  await baseApiClient.post(MEMBERSHIP_APIS.addMembershipChannels, {
    community_listing_uuid: communityListingUuid,
    membership_uuids: membershipUuids,
    channel_uuids: channelUuids,
    apply_to_existing_customers: applyToExistingCustomers,
  });
};

const postRemoveMembershipChannels = async ({
  communityListingUuid,
  membershipUuids,
  channelUuids,
  applyToExistingCustomers,
}) => {
  await baseApiClient.post(MEMBERSHIP_APIS.removeMembershipChannels, {
    community_listing_uuid: communityListingUuid,
    membership_uuids: membershipUuids,
    channel_uuids: channelUuids,
    apply_to_existing_customers: applyToExistingCustomers,
  });
};

export const syncChannelsForMembership = async ({
  communityListingUuid,
  membershipUuid,
  editedChannels,
  applyToExistingCustomers = false,
}) => {
  if (!editedChannels?.length || !membershipUuid || !communityListingUuid) {
    return;
  }

  const addedChannelUuids = editedChannels
    .filter((channel) => channel.change_type === CHANGE_STATES.added)
    .map((channel) => channel[CHANNEL_API_KEYS.CHANNEL_ID]);

  const removedChannelUuids = editedChannels
    .filter((channel) => channel.change_type === CHANGE_STATES.deleted)
    .map((channel) => channel[CHANNEL_API_KEYS.CHANNEL_ID]);

  if (!checkIsArrayEmpty(addedChannelUuids)) {
    await postAddMembershipChannels({
      communityListingUuid,
      membershipUuids: [membershipUuid],
      channelUuids: addedChannelUuids,
      applyToExistingCustomers,
    });
  }

  if (!checkIsArrayEmpty(removedChannelUuids)) {
    await postRemoveMembershipChannels({
      communityListingUuid,
      membershipUuids: [membershipUuid],
      channelUuids: removedChannelUuids,
      applyToExistingCustomers,
    });
  }
};

export const syncChannelMembershipMapping = async ({
  communityListingUuid,
  channelUuid,
  initialMembershipUuids = [],
  selectedMembershipUuids = [],
  applyToExistingCustomers = false,
}) => {
  if (!channelUuid || !communityListingUuid) return;

  const initialSet = new Set(initialMembershipUuids || []);
  const selectedSet = new Set(selectedMembershipUuids || []);

  const addedMembershipUuids = [...selectedSet].filter(
    (uuid) => !initialSet.has(uuid)
  );
  const removedMembershipUuids = [...initialSet].filter(
    (uuid) => !selectedSet.has(uuid)
  );

  if (!checkIsArrayEmpty(addedMembershipUuids)) {
    await postAddMembershipChannels({
      communityListingUuid,
      membershipUuids: addedMembershipUuids,
      channelUuids: [channelUuid],
      applyToExistingCustomers,
    });
  }

  if (!checkIsArrayEmpty(removedMembershipUuids)) {
    await postRemoveMembershipChannels({
      communityListingUuid,
      membershipUuids: removedMembershipUuids,
      channelUuids: [channelUuid],
      applyToExistingCustomers,
    });
  }
};
